/**
 * @packageDocumentation
 * @module f1/array
 */

export interface Intersection {
  /**
   * Calculate the intersection between two arrays, and results in a unique list of values
   *
   * @public
   * @function f1.difference
   * @param paired a paired set of values to mix with arr
   * @param arr a list paired with the `paired` list
   * @example
   *
   * ```ts
   * f1.difference([1, 5], [1, 2, 1, 3, 3]) => [1]
   * ```
   *
   */
  <T>(paired: T[], arr: T[]): T[];
  /**
   * @param p1
   */
  <T>(paired: T[]): (arr: T[]) => T[];
}

/**
 * @see Intersection
 */
export default <T>(paired: T[], arr: T[]): T[] => {
  const _paired = new Set(paired);
  return [...new Set(arr)].filter((v) => _paired.has(v));
};
